export default __webpack_public_path__ + "static/media/google-plus.0949c9bf.svg";